import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container} from 'react-bootstrap'
import FiltrosDescarga from './filtros-descarga'
//import FiltrosInforme from './informes'
import HistorialDescargas from './historial-descargas'
import {Auth, LoadingComponent} from 'recupero-comunes'
import { configuracionFormAction, obtenerTiposDescarga, obtenerResponsables, obtenerCriteriosFecha, obtenerDescargasPrevias} from '../../store/actions/descarga-casos-action'

const DescargaCasos = () => {
    const dispatch = useDispatch()
    const [loading, setLoading]=useState(false)
    const data_descargas = useSelector((state) => state.descargaCasosReducer)
    const { cfg_formInf } = data_descargas
    const {rutUsuario, rutOrganizacion} = Auth.currentUser()
    
    useEffect(() => {
        setLoading(true)
        let query = Buffer.from(JSON.stringify({rutcia: rutOrganizacion, idform: 86})).toString('base64')
        dispatch(configuracionFormAction(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 282})).toString('base64')
            dispatch(obtenerTiposDescarga(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({ idOrganizacion: rutOrganizacion, rol: "0070ABOEXT", tipoPersona: "0080PROVE00" })).toString('base64');
            dispatch(obtenerResponsables(query))
         })    
         .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 305})).toString('base64')
            dispatch(obtenerCriteriosFecha(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion, 'rutusr': rutUsuario && rutUsuario})).toString('base64')  
            dispatch(obtenerDescargasPrevias(query));
         })
        .then(()=>setLoading(false))
     }, [dispatch])

    return (
        <div>            
            <LoadingComponent show={loading}/>
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                        {cfg_formInf && `${cfg_formInf.cfg_formInf['descarga-casos-title']}`}
                    </Card.Header>
                    <Card.Body>
                        <FiltrosDescarga/>
                        <HistorialDescargas/>
                    </Card.Body>
                </Card>
            </Container>            
        </div>
  )
}
export default DescargaCasos 